import * as React from "react";
export class EventMBNNumber extends React.PureComponent {
    getClsMdf(classes) {
        return classes.join(" ");
    }
    render() {
        return (React.createElement("span", { className: `${this.getClsMdf(this.props.modifier)}`, "data-uat": "text-mbn-indicator" }, this.props.text));
    }
}
//# sourceMappingURL=EventMBNNumber.js.map